import React, { useEffect, useState } from 'react';
import { Button, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { PushpinOutlined } from '@ant-design/icons';
import IconCameraOn from '../../assets/icons/camera_on.svg';
import IconCameraOff from '../../assets/icons/camera_off.svg';

const CameraTree = ({ getDeviceByPage, pinned, onUpdatePinCamera }) => {
  const { t } = useTranslation();
  const [cameras, setCameras] = useState({
    data: [],
    pagination: {
      size: 'small',
      showLessItems: true
    },
    loading: false,
  });
  const { cameras: pageCamera } = useSelector((state) => state);
  const [currentSelected, setCurrentSelected] = useState();
  useEffect(() => {
    if (pinned) {
      setCurrentSelected(pinned.map((pinned) => pinned.serial));
    }
  }, [pinned]);

  useEffect(() => {
    if (pageCamera) {
      setCameras((state) => ({
        ...state,
        loading: false,
        data: pageCamera.data,
        pagination: {
          ...state.pagination,
          total: pageCamera.totalSize,
        },
      }));
    }
  }, [pageCamera]);

  const handleTableChange = (pagination) => {
    setCameras((state) => ({
      ...state,
      pagination: {
        ...state.pagination,
        current: pagination.current,
      },
      loading: true,
    }));

    return getDeviceByPage(pagination.current - 1, pagination.pageSize);
  };

  return (
    <div className="list-camera-tree-component">
      <div className="main-tree-camera">
        <Table
          size="small"
          dataSource={
            cameras &&
            cameras.data &&
            cameras &&
            cameras.data.map((camera) => ({
              ...camera,
              key: camera.serial,
            }))
          }
          pagination={cameras && cameras.pagination}
          loading={cameras && cameras.loading}
          onChange={handleTableChange}
          rowSelection={{
            preserveSelectedRowKeys: true,
            selectedRowKeys: currentSelected,
            onChange: (keys) => {
              setCurrentSelected(keys);
            },
          }}
          columns={[
            {
              title: t('Name'),
              key: 'name_of_camera_',
              render: (camera) => (
                <div className="camera-tree-name">
                  <div className="cam-icon">
                    <img
                      src={camera.state === 1 ? IconCameraOn : IconCameraOff}
                      alt="camera on"
                      className="camera-icon"
                    />
                  </div>
                  <div className="cam-name">{camera.name}</div>
                </div>
              ),
            },
          ]}
        />
      </div>
      <div className="save-button">
        <Button
          type="primary"
          onClick={() => {
            return onUpdatePinCamera(currentSelected);
          }}
          icon={<PushpinOutlined />}
        >
          {t('Apply')}
        </Button>
      </div>
    </div>
  );
};

export default CameraTree;
